import useAccordion from 'support/utilities/accordions/hooks/use-accordion'
import React from 'react'

export default function ToggleAccordionOnClick ({ name, children }) {
  const accordion = useAccordion()

  return React.Children.map(children, (child) => React.cloneElement(child, { onClick: () => accordion.toggle(name) }))
}
